export default {
    methods: {
        pad(n, width, z) {
            z = z || '0';
            n = n + '';
            return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
        },
        processHex(val) {
            //does the hex contain extra char?
            var hex = (val.length >6)?val.substr(1, val.length - 1):val;
            // is it a six character hex?
            var r = 0, g = 0, b = 0;
            if (hex.length > 3) {

                //scrape out the numerics
                r = hex.substr(0, 2);
                g = hex.substr(2, 2);
                b = hex.substr(4, 2);

                // if not six character hex,
                // then work as if its a three character hex
            } else {

                // just concat the pieces with themselves
                r = hex.substr(0, 1) + hex.substr(0, 1);
                g = hex.substr(1, 1) + hex.substr(1, 1);
                b = hex.substr(2, 1) + hex.substr(2, 1);

            }
            // return our clean values
            return [
                parseInt(r, 16),
                parseInt(g, 16),
                parseInt(b, 16)
            ]
        },
        gradientOctolo(step){
            //attach start value
            var val1RGB = this.processHex("#68dfa3");
            var val2RGB = this.processHex("#283583");
            var colors = [];
            var stepsInt = parseInt(step, 10);
            var stepsPerc = 100 / (stepsInt+1);

            // diffs between two values
            var valClampRGB = [
                val2RGB[0] - val1RGB[0],
                val2RGB[1] - val1RGB[1],
                val2RGB[2] - val1RGB[2]
            ];

            for (var i = 0; i < stepsInt; i++) {
                var clampedR = (valClampRGB[0] > 0)
                ? this.pad((Math.round(valClampRGB[0] / 100 * (stepsPerc * (i + 1)))).toString(16), 2)
                : this.pad((Math.round((val1RGB[0] + (valClampRGB[0]) / 100 * (stepsPerc * (i + 1))))).toString(16), 2);

                var clampedG = (valClampRGB[1] > 0)
                ? this.pad((Math.round(valClampRGB[1] / 100 * (stepsPerc * (i + 1)))).toString(16), 2)
                : this.pad((Math.round((val1RGB[1] + (valClampRGB[1]) / 100 * (stepsPerc * (i + 1))))).toString(16), 2);

                var clampedB = (valClampRGB[2] > 0)
                ? this.pad((Math.round(valClampRGB[2] / 100 * (stepsPerc * (i + 1)))).toString(16), 2)
                : this.pad((Math.round((val1RGB[2] + (valClampRGB[2]) / 100 * (stepsPerc * (i + 1))))).toString(16), 2);
                colors[i] = [
                    '#',
                    clampedR,
                    clampedG,
                    clampedB
                ].join('');
            }
            return colors;
        },
    },
}
